import api from '../../../shared/services/api';
import { TestsResponse } from '../types/test.types';

interface GetTestsParams {
  page?: number;
  limit?: number;
  searchQuery?: string;
  statusFilter?: string;
}

export const TestService = {
  /**
   * Get paginated tests with progress
   */
  async getTests({
    page = 1,
    limit = 9,
    searchQuery = '',
    statusFilter = '',
  }: GetTestsParams): Promise<TestsResponse> {
    const { data } = await api.get<TestsResponse>('/tests', {
      params: {
        page,
        limit,
        search: searchQuery,
        status: statusFilter,
      },
    });
    return data;
  },

  /**
   * Get diagnostic test
   */
  async getDiagnosticTest(): Promise<{ test: TestsResponse['tests'][0] }> {
    const { data } = await api.get<{ test: TestsResponse['tests'][0] }>('/tests/diagnostic');
    return data;
  },

  /**
   * Check if a test with the given name already exists for the user
   */
  async checkTestNameExists(
    userId: string,
    testName: string
  ): Promise<boolean> {
    try {
      const { data } = await api.get<{ exists: boolean }>('/tests/check-name', {
        params: {
          userId,
          name: testName,
        },
      });
      return data.exists;
    } catch (error) {
      console.error('Error checking test name:', error);
      return false; // En caso de error, asumimos que no existe para no bloquear al usuario
    }
  },
};
